import { findTraits, getMonsters, removeParentheses } from "./Logic";

export function getRandomThreat({ minParam, maxParam }) {
  let min = parseInt(minParam + "");
  let max = parseInt(maxParam + "");
  let val = Math.floor(min + Math.random() * (max - min + 1));
  return val;
}

export function getMonstersForThreatLevel({ threatLevel = 50, minCreatureThreat = 0, monsters = getMonsters() }) {
  if (minCreatureThreat > 0) {
    monsters = monsters.filter((monster) => monster?.Threat_level >= minCreatureThreat).filter((monster) => monster != null && monster !== undefined);
  }

  console.log(monsters);

  if (monsters.length === 0) {
    return {
      monsters: [],
      threat_level_left: 0,
      threat_final: 0,
    };
  }

  const result = selectMonsters({ creatures: monsters.filter((m) => m.RollOnRandom === "TRUE"), targetThreatLevel: threatLevel });
  return {
    ...result,
    monsters: sortMonstersByCreature(result?.monsters || []),
  };
}

export function getPosition() {
  let val = Math.floor(1 + Math.random() * (7 - 1 + 1));

  switch (val) {
    case 1:
      return "Norte";
    case 2:
      return "Sul";
    case 3:
      return "Oeste";
    case 4:
      return "Leste";
    case 5:
      return "Azul";
    case 6:
      return "Verde";
    case 7:
      return "Vermelho";
    default:
    // code block
  }
}

export function selectMonsters({ creatures, targetThreatLevel, selectedMonsters = [], contador = 0 }) {
  // Base case: Target threat level is reached or we ended up in a loop trying to find a valid monster,
  if (selectedMonsters.reduce((acc, monster) => acc + monster.Threat_level, 0) >= targetThreatLevel || contador > 3000) {
    return {
      monsters: selectedMonsters,
      threat_level_left: targetThreatLevel - selectedMonsters.reduce((acc, monster) => acc + monster.Threat_level, 0),
      threat_final: selectedMonsters.reduce((acc, monster) => acc + monster.Threat_level, 0),
    };
  }

  // Randomly select an unvisited creature
  let randomIndex = Math.floor(Math.random() * creatures.length);

  const selectedCreature = creatures[randomIndex];

  // Check if adding the creature's threat level would exceed the target
  const currentTotal = selectedMonsters.reduce((acc, monster) => acc + monster.Threat_level, 0);
  if (currentTotal + selectedCreature.Threat_level > targetThreatLevel || selectedCreature.models_amount <= selectedMonsters.filter((m) => m.Creature === selectedCreature.Creature).length) {
    // If it would exceed, skip this creature and try again
    return selectMonsters({ creatures, targetThreatLevel, selectedMonsters, contador: contador + 1 });
  }

  // Recursively call the function with the updated visitedIndices and selectedMonsters array

  return selectMonsters({ creatures, targetThreatLevel, selectedMonsters: [...selectedMonsters, selectedCreature], contador: contador + 1 });
}

export function getTraits({ monsters }) {
  const traits = [];
  monsters.forEach((monster) => {
    const traitsMosnter = monster.Traits.split(",");
    for (let i = 0; i < traitsMosnter.length; i++) {
      const trait = removeParentheses(traitsMosnter[i]).trim();
      if (!traits.includes(trait)) {
        traits.push(trait);
      }
    }
  });

  const traitsFinal = [];
  traits.forEach((trait) => {
    traitsFinal.push(...findTraits(trait));
  });
  return sortTraits(traitsFinal);
}

export function sortMonstersByCreature(monsters) {
  return monsters.sort((a, b) => a.Creature.localeCompare(b.Creature));
}

export function sortTraits(traits) {
  return traits.sort((a, b) => a.name.localeCompare(b.name));
}
